<template>
  <side-view class="search-by-picture">
    <template #left>
      <div class="app-panel blank-v blank-h">
        <div class="item">
          <p class="title">上传图片（jpg/png格式，且不超过5M）</p>
          <el-upload
            class="el-upload-wrap avatar"
            action="/admin/face/user/upload"
            name="face_img"
            accept="image/*"
            :show-file-list="false"
            :on-success="uploadSuccess"
            :on-error="uploadError"
            :before-upload="beforeUpload"
            :on-progress="uploadProgress"
            v-loading="uploadLoading"
          >
            <el-image :src="src" v-if="src"></el-image>
            <i class="el-icon-plus" v-else></i>
          </el-upload>
        </div>
        <div class="item">
          <p class="title">识别阈值</p>
          <el-slider v-model="threshold" :min="60"></el-slider>
        </div>
        <div class="item">
          <el-button type="primary" @click="searchParams">搜索</el-button>
          <el-button @click="resetParams">重置</el-button>
        </div>
      </div>
    </template>
    <template #right>
      <div class="app-panel" v-loading="loading">
        <div class="wrap" v-if="datas.length">
          <div class="panel" v-for="(value, index) in datas" :key="index" @click="scan(value)">
            <template v-if="value.person_type === 1">
              <el-image :src="value.user_data.face_data.attachment_access_url"></el-image>
              <div class="right">
                <p class="percent">{{value.similar}}%</p>
                <p class="number">{{value.user_data.attr_data.user_attr_name}}</p>
                <p class="type"><span>员工</span></p>
              </div>
            </template>
            <template v-else>
              <el-image :src="value.project_customer_data.face_data[0].attachment_data.attachment_access_url"></el-image>
              <div class="right">
                <p class="percent">{{value.similar.toFixed(2)}}%</p>
                <p class="number">{{value.project_customer_open_id}}</p>
                <p class="type"><span>客户</span></p>
              </div>
            </template>
          </div>
        </div>
        <div class="empty" v-else><i class="el-icon-warning"></i>暂无数据</div>
      </div>
    </template>
    <el-drawer :title="customerDialog.title" :visible.sync="customerDialog.show" center size="80%" append-to-body>
      <customer-info :id="customerDialog.id" v-if="customerDialog.show"></customer-info>
    </el-drawer>
    <!-- <el-drawer :title="staffDialog.title" :visible.sync="staffDialog.show" center size="80%" append-to-body>
      <project-staff-info :staffId="staffDialog.staffId" :id="staffDialog.id" v-if="staffDialog.show"></project-staff-info>
    </el-drawer> -->
  </side-view>
</template>

<script>
  import SearchService from '@/io/search.js';
  import SideView from '@/components/SideView.vue';
  // import ProjectStaffInfo from '@/views/ProjectStaffInfo.vue';
  import CustomerInfo from '@/views/CustomerInfo.vue';

  export default {
    name: 'SearchByPicture',
    props: {
      initVal: {
        type: Number,
        default: null
      }
    },
    watch: {
      initVal: {
        handler(newVal, oldVal) {
          if (newVal) {
            this.val = newVal;
            this.getUrl().then(() => {
              this.searchParams();
            }).catch(() => {});
          }
        },
        immediate: true
      }
    },
    data() {
      return {
        val: '',
        src: '',
        threshold: 80,
        loading: false,
        datas: [],
        uploadLoading: false,
        customerDialog: {
          title: '客户详情',
          show: false,
          id: null
        },
        staffDialog: {
          title: '员工详情',
          show: false,
          staffId: null,
          id: null
        }
      }
    },
    components: {
      SideView,
      // ProjectStaffInfo,
      CustomerInfo
    },
    methods: {
      getUrl() {
        return SearchService.searchGetUrl(this.val).then(res => {
          this.src = res.data.attachment_access_url;
        }).catch(() => {});
      },
      uploadSuccess(response, file) {
        if (response.code === 200) {
          this.src = URL.createObjectURL(file.raw);
          this.val = response.data.attachment_id;
        }
        this.uploadLoading = false;
      },
      uploadError() {
        this.$message.error('上传失败');
        this.uploadLoading = false;
      },
      uploadProgress() {
        this.uploadLoading = true;
      },
      beforeUpload(file) {
        let isExceedSize = file.size > 5242880;
        if (isExceedSize) {
          this.$message.error('图片太大');
        }
        return !isExceedSize;
      },
      searchParams() {
        if (this.val) {
          this.loading = true;
          SearchService.searchByPicture(
            this.val,
            this.threshold
          ).then(res => {
            this.datas = res.data;
          }).catch(() => {}).finally(() => {
            this.loading = false;
          });
        } else {
          this.$message.error('请上传图片');
        }
      },
      resetParams() {
        this.val = [];
        this.src = '';
        this.threshold = 80;
        this.datas = [];
      },
      scan(data) {
        if (data.person_type === 1) {
          // this.scanStaff(data.user_id);
        } else {
          this.scanCustomer(data.project_customer_data.customer_id);
        }
      },
      scanCustomer(id) {
        this.customerDialog.show = true;
        this.customerDialog.id = id;
      },
      scanStaff(id) {
        this.staffDialog.show = true;
        this.staffDialog.id = id;
      },
    },
  }
</script>

<style lang="less" scoped>
  @import '../assets/styles/tools.less';
  .search-by-picture {
    &.side-view {
      & > .left-region {
        .app-panel {
          /deep/ .item {
            & + .item {
              margin-top: 30px;
            }
            &:last-of-type {
              text-align: center;
              margin-top: 148px;
            }
            .el-upload-wrap {
              width: 100%;
              .el-upload {
                width: 100%;
                height: 220px;
              }
            }
            .title {
              font-size: 12px;
              color: @color-text-4;
              margin-bottom: 10px;
            }
          }
        }
      }
      & > .right-region {
        .app-panel {
          height: 100%;
          .wrap {
            position: relative;
            display: flex;
            flex-wrap: wrap;
            padding: 10px;
            .panel {
              box-shadow: @box-shadow-1;
              padding: 20px 20px 20px 150px;
              height: 110px;
              width: calc((100% - 570px) / 3);
              position: relative;
              margin: 10px;
              display: flex;
              transition: all @time;
              cursor: pointer;
              &:hover {
                background: linear-gradient(to left, rgb(6, 63, 187), @color-primary);
                box-shadow: @box-shadow-1;
                .right {
                  .percent {
                    color: @color-white;
                    font-size: 35px;
                    padding: 23px 0 10px 0;
                  }
                  .number {
                    color: @color-white;
                    opacity: 1;
                  }
                  .type {
                    .setImg('/search-by-picture/label-hover.png');
                    color: @color-primary;
                  }
                }
              }
              .el-image {
                width: 110px;
                height: 110px;
                position: absolute;
                top: 50%;
                left: 20px;
                margin-top: -55px;
              }
              .right {
                width: 100%;
                overflow: hidden;
                .percent {
                  text-align: right;
                  font-size: 40px;
                  padding: 31px 0;
                  transition: all @time;
                  .text-overflow;
                }
                .number {
                  text-align: right;
                  font-size: 16px;
                  .text-overflow;
                  opacity: 0;
                }
                .type {
                  .setImg('/search-by-picture/label.png');
                  position: absolute;
                  top: 0;
                  right: 20px;
                  font-size: 12px;
                  color: @color-white;
                  display: flex;
                  justify-content: center;
                  transition: all @time;
                  span {
                    padding-top: 7px;
                  }
                }
              }
            }
          }
          .empty {
            opacity: .5;
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            i {
              font-size: 24px;
              margin-bottom: 5px;
            }
          }
        }
      }
    }
  }
  /deep/ .el-drawer {
    .el-drawer__body {
      background-color: @color-1;
      padding: @distance;
    }
  }
</style>